import axios, {AxiosError} from 'axios';
import {DocumentsBatch, ErrorDocumentReportRequest, VersionedHbeDocument} from '../types';
import {getDocTypeByUid} from '../containers';


const api = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    responseType: 'json',
    baseURL: `${process.env.PUBLIC_URL}/api`,
})

function handleError(error: AxiosError) {
    const errorResponse = error.response
    console.error('api error', JSON.stringify(errorResponse, null, 2), error)

    throw new Error('api error: ' + JSON.stringify(errorResponse, null, 2))
}

export const getDocumentById = async (uid: string): Promise<DocumentsBatch> => {
    try {
        const {data} = await api.get<VersionedHbeDocument[]>(`/registry/${uid}`)
        return {
            documentId: data[0].document.blockchainUid,
            documents: data,
            documentsType: getDocTypeByUid(data[0].document.blockchainUid)
        }
    } catch (err) {
        console.error(err)
        throw err
    }
}

export const sendErrorDocumentReport = (requestBody: ErrorDocumentReportRequest): Promise<void> => {
    const {
        documentId,
        reportMsg,
        image
    } = requestBody

    const formData = new FormData()
    formData.append('documentId', documentId)
    formData.append('comment', reportMsg)
    formData.append('screenshot', image, image.name)

    try {
        return api.post('/feedback/document-error', formData)
    } catch (e) {
        throw handleError(e as AxiosError)
    }
}
